import React from "react";
import PropTypes from "prop-types";
import "./style.less";

const SegmentedToggle = ({ options, value, onChange, disabled }) => {
    return (
        <div className={"segmented-toggle" + (disabled ? " segmented-toggle--disabled" : "")}>
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    disabled={disabled}
                    className={`segmented-toggle__option${value === option.value ? " segmented-toggle__option--active" : ""}`}
                    onClick={() => { if (!disabled) onChange(option.value); }}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
};

SegmentedToggle.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.any.isRequired,
        })
    ).isRequired,
    value: PropTypes.any.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

SegmentedToggle.defaultProps = {
    disabled: false,
};

export default SegmentedToggle;
